<template>

  <div class="layout">
    <div class="head">
      <div class="head-left">
        <img src="../../assets/3.png" />
        <div style="margin: 0 12px;" >|</div>
        <div>SRM管理系统</div>
      </div>
      <div class="head-right">
        {{user.account}}
        <span class="out-login" @click="out">退出</span>
      </div>
    </div>
    <div class="flex main">
      <!-- 左侧导航 -->
      <LeftMenu :isCollapse="isCollapse" />
      <!-- 右侧内容 -->
      <RightcontentVue :class="{ isActive: isCollapse }" @changeCollapse="changeCollapse" :isCollapse="isCollapse" />
    </div>

  </div>
</template>

<script>
import LeftMenu from './LeftMenu.vue'
import RightcontentVue from './Rightcontent.vue'
import {api6, api13} from '@/api/index.js'
export default {
  components: {
    LeftMenu,
    RightcontentVue
  },
  data () {
    return {
      isCollapse: false,
      user: {}
    }
  },
  mounted () {
    if (localStorage.getItem('userInfo') === null) {
      this.$router.push('/')
    }
    api6({id: JSON.parse(localStorage.getItem('userInfo')).id}).then(res => {
      if (res.data.code === 1) {
        // 1:已认证  0：未认证
        this.user = res.data.data.user
      } else {
        this.$message.error(res.data.msg)
      }
    })
  },
  methods: {
    out () {
      api13().then(res => {
        if (res.data.code === 1) {
          this.$message.success('退出成功')
          localStorage.clear()
          location.reload()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeCollapse () {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style>
  .out-login{
    color:#409EFF;
    cursor:pointer;
  }
  .flex{
    display: flex;
  }
  .main{
    width: 100vw;
    height: calc(100vh - 60px);
    overflow: hidden;
    /* overflow-y: scroll; */
  }
  .head-right{
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.85);

  }
  .head-left>div{
    display: flex;
    align-items: center;
  }
  .head-left>img{
    width: 114px;
    height: 34px;
  }
  .head-left{
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    display: flex;
    align-content: center;
  }
  .head{
    width: 100vw;
    height: 60px;
    padding:12px 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .isActive {
    margin-left: 64px;
  }
  .layout{
    background: #f6f6f6;
  }
</style>



// WEBPACK FOOTER //
// src/view/LayOut/layout.vue